module.exports = __webpack_public_path__ + "static/media/decline.c01f372d.svg";